module.exports = __webpack_public_path__ + "static/media/Milex-Donut-Pessary-Instructions-for-Use@2x.06fe0cf5.jpg";